import { Skeleton, SkeletonRegion } from "@/components/ui/skeleton";

export default function WidgetSkeleton({
  progress = false,
}: {
  progress?: boolean;
}) {
  return (
    <SkeletonRegion className="rounded-2xl bg-card border border-border p-4 sm:p-5 shadow-card">
      <div className="flex items-center gap-3">
        <Skeleton className="size-8 shrink-0 rounded-xl" />
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="ml-auto h-4 w-16" />
      </div>
      {progress && <Skeleton className="mt-4 h-1.5 w-full rounded-full" />}
    </SkeletonRegion>
  );
}
